import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { useContextReportAniversariantes } from "src/Contexts/ReportAniversariantes/ContextReportAniversariantes";
import { IDataAniversariantes } from "src/Contexts/ReportAniversariantes/ContextReportAniversariantesTypes";
import { api } from "src/shared/setup/API/api";

/** Converte YYYY-MM-DD (input date) para MM-DD (API). */
const toMMDD = (value: string | undefined): string =>
  value ? value.slice(5) : "";

export const useHttpReportAniversariantesProdutores = () => {
  const { setLoadingTable } = useConfigPageContext();
  const { handleGetAlert } = useLayoutMainContext();
  const { filterAniversariantes, setDataAniversariantes } =
    useContextReportAniversariantes();

  const handleGet = async () => {
    const startDate = toMMDD(filterAniversariantes.startDate);
    const endDate = toMMDD(filterAniversariantes.endDate);

    if (!startDate || !endDate) {
      handleGetAlert({ message: "Informe a data inicial e final para filtrar." });
      return;
    }

    setLoadingTable(true);
    api
      .post<IDataAniversariantes>("/produtor/birthday", {
        startDate,
        endDate,
      })
      .then((res) => {
        setDataAniversariantes(res.data);
      })
      .catch((error) =>
        handleGetAlert({
          message: error?.response?.data?.message ?? "Erro ao buscar aniversariantes.",
        })
      )
      .finally(() => setLoadingTable(false));
  };

  return { handleGet };
};
